import axios from "axios";
import decrypt from "../../utils/helpers/decrypt";
import encrypt from "../../utils/helpers/encrypt";
import StorageService from "../storage/storage.service";
import { showMessageOnFailure } from "../../store/error.actions";
import store from "../../store/store";
import { APIResponseCodes } from "../../utils/constants/keys.constants";
import { logoutUser, refreshToken } from "../../store/authentication/authentication.actions";
import { hideLoader } from "../../store/Loader/loader.slice";
import { setEmailVerification, setFirstTimeUser, setPrimaryUser, setUser } from "../../store/authentication/authentication.slice";
import { setPageNumber } from "../../store/pageData/pageData.slice";
import { getDeviceId } from "../../utils/helpers/deviceId";

/**
 * HTTP service functions will be used to make all the api calls
 *
 */

// const baseURL = "https://api-finfabrik.kfintech.com"; //prod
// const baseURL = "https://uatapi-finfabrik.kfintech.com"; //uat
// const baseURL = "https://uatapi-mfcentral.kfintech.com";
const baseURL = "https://kfinapi.asmadiya.net"; //dev
// const baseURL = "http://3.109.123.77:4208"; //'http://115.160.220.50:4208/API_BASE_PATH/api/v1'
// const baseURL = "https://hpj3cfwj-4210.inc1.devtunnels.ms"

/** Header creation */

const createHeaders = () => {
  axios.defaults.baseURL = baseURL;
  const { user } = StorageService.getFromStorage(["user"]);

  return {
    headers: { Authorization: "Bearer " + user?.token, "X-Device-ID": getDeviceId() },
    // headers: {'Authorization' : `Bearer `}
  };
};
// const createHeaders = () => {
//   //   axios.defaults.baseURL = baseURL;
//   const { user } = StorageService.getFromStorage(["user"]);

//   const headers: any = {
//     "x-device-id": getDeviceId(), 
//   };

//   if (user?.token) {
//     headers["Authorization"] = "Bearer " + user.token;
//   }

//   return { headers };
// };

/** HTTP - GET */
const getDetails = async (getUrl: string, callbackFun?: Function) => {
  try {
    const header = createHeaders();
    const response: any = await axios.get(baseURL + `${getUrl}`, header).catch((reason) => {
      if (reason.response) {
        return reason.response;
      }
    });

    if (response?.status === 401) {
      if (response.data?.statusCode === APIResponseCodes.INVALID_ACCESS_TOKEN) {
        let callback = typeof callbackFun === "undefined" ? () => {} : callbackFun;
        store.dispatch(hideLoader());
        refreshToken(getUrl, callback);
        return response.data;
      } else {
        const userData = {
          user_id: "",
          email: "",
          organization_name: "",
          phone_number: "",
          rbi_code: "",
          registered_with_rbi: "",
          registered_with_sebi: "",
          sebi_code: "",
          technical_service_provider: "",
          user_category: [],
        };
        store.dispatch(setUser(userData));
        localStorage.clear();
        sessionStorage.clear();
        store.dispatch(hideLoader());
        store.dispatch(logoutUser);
        store.dispatch(setPageNumber(0));
        store.dispatch(showMessageOnFailure("Your session expired. Please login again..."));
        store.dispatch(setPrimaryUser(false));
        store.dispatch(setFirstTimeUser(false));
        store.dispatch(setEmailVerification(false));
        return response.data;
      }
    }

    if (response?.status === 403) {
      store.dispatch(showMessageOnFailure("You don't have access to this page. Please contact your organisation admin..."));
    }

    if (response?.status === 200) {
      let decryptedPayload = await decrypt(response.data.data);
      // console.log({ statusCode: response.data.statusCode, message: response.data.message, data: decryptedPayload });
      return { statusCode: response.data.statusCode, message: response.data.message, data: decryptedPayload };
    }

    if (response?.status === 400) {
      return response.data;
    }

    return response;
  } catch (error) {
    return { statusCode: APIResponseCodes.SERVER_ERROR, message: "server error" };
  }
};

/** HTTP - POST */
const postDetails = async (postUrl: string, payload: any, callbackFun?: Function) => {
  const header = createHeaders();
  console.log(header, 'Header Post');
  try {
    const response: any = await axios.post(baseURL + `${postUrl}`, { data: encrypt(payload) }, header).catch((reason) => {
      if (reason.response) {
        return reason.response;
      }
    });
    if (response?.status === 401) {
      if (response.data?.statusCode === APIResponseCodes.INVALID_ACCESS_TOKEN) {
        let callback = typeof callbackFun === "undefined" ? () => {} : callbackFun;
        refreshToken(postUrl, callback);
        return response.data;
      }

      const userData = {
        user_id: "",
        email: "",
        organization_name: "",
        phone_number: "",
        rbi_code: "",
        registered_with_rbi: "",
        registered_with_sebi: "",
        sebi_code: "",
        technical_service_provider: "",
        user_category: [],
      };
      store.dispatch(setUser(userData));
      localStorage.clear();
      sessionStorage.clear();
      store.dispatch(logoutUser);
      store.dispatch(hideLoader());
      store.dispatch(showMessageOnFailure("Your session expired. Please login again..."));
      store.dispatch(setPageNumber(0));
      store.dispatch(setPrimaryUser(false));
      store.dispatch(setFirstTimeUser(false));
      store.dispatch(setEmailVerification(false));
      return response.data;
    }

    if (response?.status === 403) {
      store.dispatch(showMessageOnFailure("You don't have access to this page. Please contact your organisation admin..."));
    }

    if (response.status === 404) {
      store.dispatch(showMessageOnFailure("Unable to make request with given details..."));
    }

    if (response.status === 200) {
      let decryptedPayload = await decrypt(response.data.data);
      return { statusCode: response.data.statusCode, message: response.data.message, data: decryptedPayload };
    }

    if (response.status === 400) {
      store.dispatch(showMessageOnFailure(response.data.message));
      return response.data;
    }

    return response;
  } catch (error) {
    store.dispatch(showMessageOnFailure("Sorry for the inconvenience. We are having trouble processing your request at the moment. Please try again some time later..."));
    return { statusCode: APIResponseCodes.SERVER_ERROR, message: "server error" };
  }
};

/** HTTP - POST blob/binary response */
const postDetailsBlob = async (postUrl: string, payload: any, callbackFun?: Function) => {
  const header = createHeaders();
  console.log(header, 'Header Blob Post');

  try {
    const response: any = await axios
      .post(baseURL + `${postUrl}`, { data: encrypt(payload) }, { ...header, responseType: "blob" })
      .catch((reason) => {
        if (reason.response) {
          return reason.response;
        }
      });

    if (response?.status === 401) {
      const reader = new FileReader();
      const errorData = await new Promise<any>((resolve) => {
        reader.onload = () => {
          try {
            resolve(JSON.parse(reader.result as string));
          } catch {
            resolve(null);
          }
        };
        reader.onerror = () => resolve(null);
        reader.readAsText(response.data);
      });

      if (errorData?.statusCode === APIResponseCodes.INVALID_ACCESS_TOKEN) {
        const callback = typeof callbackFun === "undefined" ? () => {} : callbackFun;
        refreshToken(postUrl, callback);
        return errorData;
      }

      const userData = {
        user_id: "",
        email: "",
        organization_name: "",
        phone_number: "",
        rbi_code: "",
        registered_with_rbi: "",
        registered_with_sebi: "",
        sebi_code: "",
        technical_service_provider: "",
        user_category: [],
      };
      store.dispatch(setUser(userData));
      localStorage.clear();
      sessionStorage.clear();
      store.dispatch(logoutUser);
      store.dispatch(hideLoader());
      store.dispatch(showMessageOnFailure("Your session expired. Please login again..."));
      store.dispatch(setPageNumber(0));
      store.dispatch(setPrimaryUser(false));
      store.dispatch(setFirstTimeUser(false));
      store.dispatch(setEmailVerification(false));
      return errorData;
    }

    if (response?.status === 403) {
      store.dispatch(showMessageOnFailure("You don't have access to this page. Please contact your organisation admin..."));
    }

    if (response?.status === 404) {
      store.dispatch(showMessageOnFailure("Unable to make request with given details..."));
    }

    if (response?.status === 400) {
      const errorText = await response.data.text?.();
      if (errorText) {
        try {
          const errorJson = JSON.parse(errorText);
          store.dispatch(showMessageOnFailure(errorJson.message));
          return errorJson;
        } catch {
          store.dispatch(showMessageOnFailure("Unable to process the download request."));
        }
      }
      return response;
    }

    if (response?.status === 200) {
      return response;
    }

    return response;
  } catch (error) {
    store.dispatch(showMessageOnFailure("Sorry for the inconvenience. We are having trouble processing your request at the moment. Please try again some time later..."));
    return { statusCode: APIResponseCodes.SERVER_ERROR, message: "server error" };
  }
};

/** HTTP - POST without headers [used for login purpose] */
const postWithoutCredentials = async (postUrl: string, payload: any) => {
  //   axios.defaults.baseURL = baseURL;

  try {
    const headers = { "x-device-id": getDeviceId() };
    const response: any = await axios.post(baseURL + `${postUrl}`, { data: encrypt(payload) }, { headers }).catch((reason) => {
      if (reason.response) {
        return reason.response;
      }
    });

    if (response.status === 404) {
      store.dispatch(showMessageOnFailure("Unable to make request with given details..."));
    }

    if (response.status === 400) {
      store.dispatch(showMessageOnFailure(response.data.message));
      return response.data;
    }

    if (response.status === 200) {
      let decryptedPayload = await decrypt(response.data.data);
      return { statusCode: response.data.statusCode, message: response.data.message, data: decryptedPayload };
    }

    return response;
  } catch (error) {
    store.dispatch(showMessageOnFailure("Sorry for the inconvenience. We are having trouble processing your request at the moment. Please try again some time later..."));
    return { statusCode: APIResponseCodes.SERVER_ERROR, message: "server error" };
  }
};

/** HTTP - GET without headers */
const getWithoutCredentials = async (getUrl: string) => {
  try {
    const headers = { "x-device-id": getDeviceId() };
    const response: any = await axios.get(baseURL + `${getUrl}`, { headers }).catch((reason) => {
      if (reason.response) {
        return reason.response;
      }
    });

    if (response.status === 404) {
      store.dispatch(showMessageOnFailure("Unable to make request with given details..."));
    }

    if (response?.status === 200) {
      let decryptedPayload = await decrypt(response.data.data);
      return { statusCode: response.data.statusCode, message: response.data.message, data: decryptedPayload };
    }

    if (response?.status === 400) {
      store.dispatch(showMessageOnFailure(response.data.message));
      return response.data;
    }

    return response;
  } catch (error) {
    return { statusCode: APIResponseCodes.SERVER_ERROR, message: "server error" };
  }
};

/** Post Multipart Data */
const postMultipartDetails = async (postUrl: string, formData: any) => {
  const header = createHeaders();

  try {
    const response: any = await axios.post(baseURL + `${postUrl}`, formData, header).catch((reason) => {
      if (reason.response) {
        return reason.response;
      }
    });

    if (response?.status === 401) {
      const userData = {
        user_id: "",
        email: "",
        organization_name: "",
        phone_number: "",
        rbi_code: "",
        registered_with_rbi: "",
        registered_with_sebi: "",
        sebi_code: "",
        technical_service_provider: "",
        user_category: [],
      };
      store.dispatch(setUser(userData));
      localStorage.clear();
      sessionStorage.clear();
      store.dispatch(logoutUser);
      store.dispatch(hideLoader());
      store.dispatch(showMessageOnFailure("Your session expired. Please login again..."));
      store.dispatch(setPageNumber(0));
      return response.data;
    }

    if (response.status === 404) {
      store.dispatch(showMessageOnFailure("Unable to make request with given details..."));
    }

    if (response.status === 400) {
      store.dispatch(showMessageOnFailure(response.data.message));
      return response.data;
    }

    if (response.status === 200) {
      let decryptedPayload = await decrypt(response.data.data);
      return { statusCode: response.data.statusCode, message: response.data.message, data: decryptedPayload };
    }

    return response;
  } catch (error) {
    store.dispatch(showMessageOnFailure("Sorry for the inconvenience. We are having trouble processing your request at the moment. Please try again some time later..."));
    return { statusCode: APIResponseCodes.SERVER_ERROR, message: "server error" };
  }
};

export { getDetails, postWithoutCredentials, postDetails, postDetailsBlob, getWithoutCredentials, postMultipartDetails, baseURL };
